// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageSwitcher_wrapper__TQvdM","inactive":"LanguageSwitcher_inactive__aONnw"};